import React from 'react';
import { TWILIGHT_NAVY, MUTED_GOLD, SHELL_WHITE, alpha } from '../../../theme/colors';
import { SCIENCE_EYEBROW, HEADLINE_REGULAR, HEADLINE_ITALIC, MISSION_TEXT, SCIENCE_BEATS, CLOSING_STATEMENT, REFERENCES, REFERENCES_DISCLAIMER } from './scienceData';

const DIVIDER = `1px solid ${alpha('navy', 0.18)}`;

// Single stacked column, no sticky — the pinned-column concept doesn't carry
// to mobile (matches Features' precedent of a genuinely different mobile
// layout, not just a resize of desktop).
const ScienceSectionMobile = () => (
  <div style={{ width: '100%', backgroundColor: SHELL_WHITE, padding: '48px 24px', boxSizing: 'border-box' }}>
    <div style={{ fontFamily: 'DM Sans', fontSize: 11, fontWeight: 500, letterSpacing: '0.13em', textTransform: 'uppercase', color: MUTED_GOLD }}>
      {SCIENCE_EYEBROW}
    </div>
    <div style={{ fontFamily: 'Instrument Serif', fontSize: 34, lineHeight: '114%', color: TWILIGHT_NAVY, marginTop: 18 }}>
      {HEADLINE_REGULAR}
      <span style={{ fontStyle: 'italic' }}>{HEADLINE_ITALIC}</span>
      <sup style={{ fontSize: '0.5em' }}>1</sup>
    </div>
    <div style={{ fontFamily: 'DM Sans', fontSize: 15, lineHeight: '175%', color: TWILIGHT_NAVY, marginTop: 18 }}>{MISSION_TEXT}</div>

    <div style={{ marginTop: 36 }}>
      {SCIENCE_BEATS.map((beat, i) => (
        <div
          key={beat.title}
          style={{
            padding: '28px 0',
            // borderBottom: i < SCIENCE_BEATS.length - 1 ? DIVIDER : 'none',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 6, height: 6, flexShrink: 0, borderRadius: '50%', backgroundColor: alpha(beat.accent, 1) }} />
            <div style={{ fontFamily: 'Instrument Serif', fontStyle: 'italic', fontSize: 20, color: TWILIGHT_NAVY }}>{beat.title}</div>
          </div>
          <div style={{ fontFamily: 'DM Sans', fontSize: 14, lineHeight: '175%', color: alpha('navy', 1), paddingLeft: 16, marginTop: 8 }}>
            {beat.description}
            <sup style={{ fontSize: '0.75em' }}>{beat.citation}</sup>
          </div>
        </div>
      ))}
    </div>

    <div style={{ fontFamily: 'Instrument Serif', fontStyle: 'italic', fontSize: 26, lineHeight: '130%', color: TWILIGHT_NAVY, marginTop: 44 }}>
      {CLOSING_STATEMENT}
    </div>

    <div style={{ marginTop: 44, paddingTop: 20, borderTop: DIVIDER }}>
      {REFERENCES.map((ref) => (
        <div key={ref.n} style={{ fontFamily: 'DM Sans', fontSize: 10, lineHeight: '160%', letterSpacing: '0.02em', color: alpha('navy', 0.45), marginBottom: 12 }}>
          {ref.n}. {ref.text}
        </div>
      ))}
      <div style={{ fontFamily: 'DM Sans', fontSize: 10, lineHeight: '160%', letterSpacing: '0.02em', color: alpha('navy', 0.45) }}>
        {REFERENCES_DISCLAIMER}
      </div>
    </div>
  </div>
);

export default ScienceSectionMobile;
